const style = (theme) => {
  const output = {
    root: {
      position: 'fixed',
      top: 0,
      right: 0,
      width: '100%',
      height: '100%',
      background: theme.getRgba(theme.colors[0], 0.7),
      transition: `opacity 0.3s ${theme.easings['power4.out']}`,
      zIndex: theme.zindex.modal,
      opacity: 0,
      pointerEvents: 'none',
    },
    modal: {
      position: 'fixed',
      top: 0,
      right: 0,
      width: '50%',
      height: '100%',
      background: theme.colors[1],
    },
    close: {
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: 0,
      pointerEvents: 'none',
      cursor: 'pointer',
      position: 'absolute',
      top: '50%',
      left: 0,
      transform: 'translate(-50%, -50%)',
      width: 100,
      height: 100,
      background: theme.colors[3],
      borderRadius: '50%',
      transition: `all 0.3s ${theme.easings['power4.out']}`,
      '& svg': {
        width: 18,
        height: 18,
        fill: theme.colors[1],
      },
      '&:hover': {
        background: theme.colors[4],
      },
    },
    container: {
      width: '100%',
      height: '100%',
      position: 'relative',
    },
    wrapper: {
      maxHeight: '100%',
      overflow: 'auto',
    },
    scrollable: {
      extend: theme.wrapper,
      paddingTop: 60,
      paddingBottom: 60,
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    left: {
      flex: '0 0 45%',
    },
    right: {
      flex: '0 0 45%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    category: {
      fontSize: 12,
      color: theme.colors[4],
      marginBottom: '10px !important',
    },
    secondLine: {
      marginTop: 120,
    },
    thirdLine: {
      marginTop: 60,
    },
    info: {
      position: 'relative',
      display: 'flex',
    },
    contact: {},
    icon: {
      display: 'none',
      position: 'absolute',
      top: 5,
      left: '-15px',
      transform: 'translateX(-100%)',
      marginRight: 15,
      '& svg': {
        width: 25,
        height: 25,
        '&.center': {
          fill: theme.colors[3],
        },
        '&.green': {
          fill: theme.colors[8],
        },
      },
    },
    title: {
      fontSize: 24,
      color: theme.colors[0],
      marginBottom: 30,
    },
    address: {
      fontSize: 16,
      color: theme.colors[5],
      marginBottom: 20,
    },
    iconsList: {
      '& > *:not(:last-child)': {
        marginBottom: 15,
      },
    },
    itemList: {
      display: 'flex',
      '& svg': {
        width: 15,
        height: 15,
        fill: theme.colors[0],
        marginTop: 5,
        marginRight: 15,
      },
      '& a': {
        fontSize: 16,
        color: theme.colors[5],
        marginBottom: 0,
        transition: `color 0.3s ${theme.easings['power4.out']}`,
        '&:hover': {
          color: theme.colors[3],
        },
      },
    },
    pretitle: {
      fontSize: 10,
      textTransform: 'uppercase',
      marginBottom: 20,
    },
    description: {
      fontSize: 14,
      color: theme.colors[0],
    },
    hours: {
      fontSize: 13,
      color: theme.colors[5],
      '& span': {
        color: theme.colors[0],
      },
    },
    full: {
      flex: '0 0 100%',
      width: '100%',
      overflow: 'hidden',
    },
    gallery: {
      '& .slick-list': {
        width: '100%',
        margin: '0 auto',
      },
      '& .slick-arrow': {
        zIndex: 1,
        backgroundColor: theme.colors[3],
        '& svg': {
          fill: theme.colors[1],
        },
      },
      '& .slick-prev': {
        left: 25,
      },
      '& .slick-next': {
        right: 25,
      },
      '& .Carousel__carouselItem': {
        padding: 0,
      },
      '& .Carousel__carouselImg': {
        position: 'relative',
        zIndex: 1,
        paddingBottom: '54%',
        '& img': {
          width: '100%',
          height: '110%',
        },
      },
    },
    visible: {
      opacity: 1,
      pointerEvents: 'all',
    },
  }

  output[theme.mediaInverse.md] = {
    modal: {
      width: '90%',
    },
    scrollable: {
      padding: '0 20px 0 40px',
      paddingTop: 40,
      paddingBottom: 40,
    },
    close: {
      width: 60,
      height: 60,
      '& svg': {
        width: 12,
        height: 12,
      },
    },
    icon: {
      position: 'relative',
      top: 'unset',
      left: 'unset',
      transform: 'none',
    },
    left: {
      flex: '100%',
    },
    right: {
      flex: '100%',
    },
    contact: {
      marginTop: 30,
      '& > *:not(:last-child)': {
        marginBottom: 20,
      },
    },
    secondLine: {
      marginTop: 60,
    },
    thirdLine: {
      marginTop: 30,
    },
  }

  return output
}

export default style
